exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-sp-components-molecules-NameInputForm-___NameInputForm__title___3cPoW {\n  margin-bottom: 8px;\n}\n\n.src-sp-components-molecules-NameInputForm-___NameInputForm__notice___rRiDb {\n  margin-bottom: 72px;\n}\n\n.src-sp-components-molecules-NameInputForm-___NameInputForm__notice___rRiDb > p {\n    line-height: 28px;\n  }\n", ""]);

// exports
exports.locals = {
	"title": "src-sp-components-molecules-NameInputForm-___NameInputForm__title___3cPoW",
	"notice": "src-sp-components-molecules-NameInputForm-___NameInputForm__notice___rRiDb"
};